module.exports = __webpack_public_path__ + "img/badge-team-brightbg.7a526bec.svg";